import React from 'react';
import TimeAgo from 'react-timeago';
import PropTypes from 'prop-types';

const formatter = (value, unit) => {
  if (unit === 'second' && value < 60) return 'Just now';
  if (unit === 'minute') return `${value} ${value === 1 ? 'minute' : 'minutes'} ago`;
  if (unit === 'hour') return `${value} ${value === 1 ? 'hour' : 'hours'} ago`;
  if (unit === 'day') return `${value} ${value === 1 ? 'day' : 'days'} ago`;
  if (unit === 'week') return `${value} ${value === 1 ? 'week' : 'weeks'} ago`;
  if (unit === 'month') return `${value} ${value === 1 ? 'month' : 'months'} ago`;
  if (unit === 'year') return `${value} ${value === 1 ? 'year' : 'years'} ago`;
  return '-';
};

const FormattedTimeAgo = ({ date }) => (
  <TimeAgo date={ date } formatter={ formatter } />
);

FormattedTimeAgo.propTypes = {
  date: PropTypes.string.isRequired
};

export default FormattedTimeAgo;
